import { Button } from '@mui/material'
import { ReactElement } from 'react'

interface Props {
  text?: string
  handleClick: () => void
  disabled?: boolean
  icon?: ReactElement
  style?: any
}

const DevelopusButton = (props: Props) => {
  const handleClick = () => {
    props.handleClick()
  }

  return (
    <>
      <Button
        onClick={handleClick}
        startIcon={props.icon}
        sx={{ ...props.style, textTransform: 'capitalize' }}
        disabled={props.disabled}
      >
        {props.text}
      </Button>
    </>
  )
}

export default DevelopusButton
